"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HLS_TIMED_METADATA_LOADED = exports.HLS_STREAM_NO_LONGER_LIVE = exports.HLS_DEFAULT_ALLOWED_MAX_LATENCY_DELAY = exports.HLSController = void 0;
var _hls = _interopRequireDefault(require("hls.js"));
var _eventemitter = require("eventemitter2");
var _FeatureFlags = require("../../services/FeatureFlags");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var HLS_TIMED_METADATA_LOADED = "hls-timed-metadata";
exports.HLS_TIMED_METADATA_LOADED = HLS_TIMED_METADATA_LOADED;
var HLS_STREAM_NO_LONGER_LIVE = "hls-stream-no-longer-live";
exports.HLS_STREAM_NO_LONGER_LIVE = HLS_STREAM_NO_LONGER_LIVE;
var HLS_DEFAULT_ALLOWED_MAX_LATENCY_DELAY = 10; // seconds
exports.HLS_DEFAULT_ALLOWED_MAX_LATENCY_DELAY = HLS_DEFAULT_ALLOWED_MAX_LATENCY_DELAY;
var HLSController = /*#__PURE__*/function () {
  function HLSController(hlsUrl, videoRef) {
    _classCallCheck(this, HLSController);
    _defineProperty(this, "hls", void 0);
    _defineProperty(this, "videoRef", void 0);
    _defineProperty(this, "eventEmitter", new _eventemitter.EventEmitter2());
    _defineProperty(this, "isLive", true);
    this.hls = new _hls["default"](this.getHLSConfig());
    this.videoRef = videoRef;
    this.hls.loadSource(hlsUrl);
    this.hls.attachMedia(videoRef.current);
    this.handleHLSTimedMetadataParsing();
    this.ControllerEvents = [HLS_TIMED_METADATA_LOADED, HLS_STREAM_NO_LONGER_LIVE];
  }
  _createClass(HLSController, [{
    key: "reset",
    value: function reset() {
      if (this.hls && this.hls.media) {
        this.hls.detachMedia();
        this.hls = null;
      }
      this.eventEmitter = null;
    }

    /**
     *
     * @returns returns a Number which represents current
     * quality level. -1 if currentlevel is set to "Auto"
     */
  }, {
    key: "getCurrentLevel",
    value: function getCurrentLevel() {
      return this.hls.currentLevel;
    }

    /**
     *
     * @param { Number } currentLevel - currentLevel we want to
     * set the stream to. -1 for Auto
     */
  }, {
    key: "setCurrentLevel",
    value: function setCurrentLevel(currentLevel) {
      var newLevel = this.hls.levels.findIndex(function (level) {
        return level.height === currentLevel.height;
      });
      this.hls.currentLevel = newLevel;
    }
  }, {
    key: "jumpToLive",
    value: function jumpToLive() {
      var videoEl = this.videoRef.current;
      videoEl.currentTime = this.hls.liveSyncPosition;
      if (videoEl.paused) {
        try {
          videoEl.play();
        } catch (err) {
          console.error("Attempt to jump to live position Failed.", err);
        }
      }
    }

    /**
     * Event listener. Also takes HLS JS events. If its
     * not a Controller's event, it just forwards the
     * request to hlsjs
     * @param {string | Hls.Events} eventName
     * @param {Function} eventCallback
     */
  }, {
    key: "on",
    value: function on(eventName, eventCallback) {
      /**
       * slight optimization. If the user is not
       * interested in HLS_STREAM_NO_LONGER_LIVE,
       * we don't have to register time_update event
       * as it is a bit costly.
       */
      if (eventName === HLS_STREAM_NO_LONGER_LIVE) {
        this.enableTimeUpdateListener();
      }
      if (this.ControllerEvents.indexOf(eventName) === -1) {
        this.hls.on(eventName, eventCallback);
      } else {
        this.eventEmitter.addListener(eventName, eventCallback);
      }
    }

    // listen for pause, play as well to show not live if paused
  }, {
    key: "enableTimeUpdateListener",
    value: function enableTimeUpdateListener() {
      var _this = this;
      this.videoRef.current.addEventListener("timeupdate", function (_) {
        if (_this.hls) {
          var videoEl = _this.videoRef.current;
          var allowedDelay = _this.getHLSConfig().liveMaxLatencyDuration || HLS_DEFAULT_ALLOWED_MAX_LATENCY_DELAY;
          _this.isLive = _this.hls.liveSyncPosition - videoEl.currentTime <= allowedDelay;
          if (!_this.isLive) {
            _this.eventEmitter.emit(HLS_STREAM_NO_LONGER_LIVE);
          }
        }
      });
    }
  }, {
    key: "handleHLSTimedMetadataParsing",
    value: function handleHLSTimedMetadataParsing() {
      var _this2 = this;
      /**
       * Metadata are automatically parsed and added to the video element's
       * textTrack cue by hlsjs as they come through the stream.
       * in FRAG_CHANGED, we read the cues and emit HLS_METADATA_LOADED
       * when the current fragment has a metadata to play.
       */
      this.hls.on(_hls["default"].Events.FRAG_CHANGED, function (_, _ref) {
        var frag = _ref.frag;
        try {
          if (_this2.videoRef.current.textTracks.length === 0) {
            return;
          }
          var fragStartTime = frag.start;
          /**
           * this destructuring is needed because the cues array not a pure
           * JS array and prevents us from
           * performing array operations like map(),filter() etc.
           */
          var metadata = _toConsumableArray(_this2.videoRef.current.textTracks[0].cues);
          /**
           * filter out only the metadata that have startTime set to future.
           * (i.e) more than the current fragment's startime.
           */
          var metadataAfterFragStart = metadata.filter(function (mt) {
            return mt.startTime >= fragStartTime;
          });
          metadataAfterFragStart.forEach(function (mt) {
            var timeDifference = mt.startTime - fragStartTime;
            var fragmentDuration = frag.end - frag.start;
            if (timeDifference < fragmentDuration) {
              var payload = mt.value.data;
              /**
               * we start a timeout for difference seconds.
               * NOTE: Due to how setTimeout works, the time is only the minimum gauranteed
               * time JS will wait before calling emit(). It's not guaranteed even
               * for timeDifference = 0.
               */
              setTimeout(function () {
                /** Even though duration comes as an attribute in the stream,
                 * HlsJs doesn't give us a property duration directly. So
                 * we calculate it ouselves. This is same as reading
                 * EXT-INF tag.
                 */
                var duration = mt.endTime - mt.startTime;

                /**
                 * finally emit event letting the user know its time to
                 * do whatever they want with the payload
                 */
                _this2.eventEmitter.emit(HLS_TIMED_METADATA_LOADED, {
                  payload: payload,
                  duration: duration,
                  metadata: mt
                });
              }, timeDifference * 1000);
            }
          });
        } catch (e) {
          console.error("FRAG_CHANGED event error", e);
        }
      });
    }
  }, {
    key: "getHLSConfig",
    value: function getHLSConfig() {
      if (_FeatureFlags.FeatureFlags.optimiseHLSLatency()) {
        // should reduce the latency by around 2-3 more seconds. Won't work well without good internet.
        return {
          enableWorker: true,
          liveSyncDuration: 1,
          liveMaxLatencyDuration: 5,
          liveDurationInfinity: true,
          highBufferWatchdogPeriod: 1
        };
      }
      return {
        enableWorker: true,
        maxBufferLength: 20,
        backBufferLength: 10
      };
    }
  }]);
  return HLSController;
}();
exports.HLSController = HLSController;